
import {Tooltip2} from '@api'
import {Tooltip} from '@material-ui/core'
import {PrimaryIconButton} from 'centric-ui-components'
import {useGroupByGroupStore, } from './'
import {site, StackView} from '@stores'
import {_, classNames, React, useLayoutEffect, observer, useIntersectionObserver, Fragment} from '@api'
import * as css from './GroupByGroupHeaderStacked.css'
import {ButtonGroup, Icon, IconName, Spinner} from '@blueprintjs/core'

export const GroupByGroupHeaderStacked = observer<{ showButtons?}>(({showButtons}) => {
  const store = useGroupByGroupStore(),
    {
      strings, isExpanded, isSelected, preload,
      levelOfDetail, isGroupSearch, toggleGroupSearch, parentStore,
      props: {
        firstExpandedInRow, path, tabIndex, group,
        hideChildren, info, level, groupName,
        className, mustTerms, mustNotTerms,
        attract, loading, info: {count},
        ...restProps
      },
      toggleExpanded, storeNode, settings: {stackView},
      toggleLevelOfDetail,
      catalog: {settings: {imageRatio}}
    } = store

  const productStore = storeNode?.productStore

  // Don't show the header until the all children of our parent have loaded
  // if (parentStore && !parentStore.allChildrenLoaded) {
  //   return null
  // }

  const [entry, observerRef] = useIntersectionObserver()
  const everVisible = store.everVisible || entry.isIntersecting
  useLayoutEffect(() => { if (everVisible) store.everVisible = everVisible}, [everVisible])

  const title = info.title || strings.noValue

  return (
    <div key={group}
         ref={observerRef}
         className={classNames(className, css.root)}
         {..._.omit(restProps, 'isExpanded', 'specs', 'node', '__typename', 'specStack')}
         data-key={info.key}
         tabIndex={tabIndex}
         data-image-ratio={imageRatio}
         data-lod={levelOfDetail}
         data-count={count}
         data-expanded={isExpanded}
         data-type='GroupByContainer'
         data-hide-children={hideChildren || false}
         data-level={level}
         data-loading={productStore?.isLoadingMore}
         data-selected={isSelected}
         data-group-name={groupName}
         data-attract={attract ? attract : undefined}
         onClick={site.touchDevice ? undefined : store.onClick}
         onMouseEnter={!preload && !isExpanded ? store.onMouseEnter : undefined}
         onMouseLeave={!preload && !isExpanded ? store.onMouseLeave : undefined}
         onTouchEnd={site.touchDevice ? e => {
           store.onClick(e as any)
           store.onTouchDoubleTap(e)
         } : undefined}
         //onDoubleClick_forTabNode={store.onDoubleClick_forTabNode}
         data-inline-search={false}
    >

      {/*<PrimaryIconButton icon={<Icon icon={isExpanded ? 'minus' : 'plus'}/>} onClick={toggleExpanded}/>*/}

      {/*<div className={css.groupLabel}>{groupHeader}</div>*/}

      <div className={css.groupTitle} data-type='groupTitle'>
        <span className={css.title}
              style={{WebkitBoxOrient: 'vertical'}}
              title={title}>{title}</span>
        {productStore?.isLoadingMore && isExpanded ? <Spinner className={css.spinner} size={14}/> : count != null && <span className={css.count}>({count})</span>}
      </div>

      {(showButtons || (isExpanded && productStore && !productStore?.isLoadingMore)) && <ButtonGroup className={css.buttons}>
		  <StackToolbarButton tooltip='Collapse' view='collapsed' icon='merge-columns'/>
        {<StackToolbarButton tooltip='Spread' view='spread' icon='split-columns'/>}
		  <StackToolbarButton tooltip='Grid' view='grid' icon='grid'/>
		  <StackToolbarButton tooltip='Full-Width' view='expanded' icon='arrows-horizontal'/>

        {/*<SearchField2 className={css.search} ref={setSearchRef}/>*/}

	  </ButtonGroup>}

      <ButtonGroup className={css.rightButtons}>
        {isExpanded && <Tooltip2 content={strings.search}>
          <PrimaryIconButton grouped={false} icon={<Icon icon='search'/>} active={isGroupSearch} onClick={toggleGroupSearch}/>
        </Tooltip2>}

        {isExpanded && storeNode && <Tooltip2 content={strings.levelOfDetail(levelOfDetail)}>
          <PrimaryIconButton icon={<Icon icon={levelOfDetail === 1 ? 'zoom-out' : 'zoom-in'} />}
                             //active={levelOfDetail == 1}
                             onClick={toggleLevelOfDetail}/>
        </Tooltip2>}

        {isExpanded && !productStore?.isLoadingMore && <Fragment>
          {stackView != 'expanded' && productStore?.timesClicked > 1 && <PreviousPageButton/>}
          {productStore?.hasMore && stackView != 'expanded'
           ? <NextPageButton/> : null}
        </Fragment>}

        <Tooltip2 content={`${!isExpanded ? strings.expand : strings.collapse} '${title}'`}>
          <PrimaryIconButton className={css.toggleExpandCollapse} icon={<Icon icon={isExpanded ? 'chevron-down' : 'chevron-up'}/>} onClick={toggleExpanded}/>
        </Tooltip2>
      </ButtonGroup>


      {/*<GroupByButtons isDragOver={isDragOver} grouping={store.grouping} specStack={specStack} items={items} location={'row'} isUnassigned={isUnassigned} {...buttonToolbarProps}*/}
      {/*                level={level}/>*/}
    </div>
  )
})

const PreviousPageButton = observer(() => {
  const {storeNode: {productStore: {onPageBack, itemsPerClick, timesClicked, totalCount}}} = useGroupByGroupStore(),
    from = Math.max((timesClicked - 2) * itemsPerClick + 1, 1),
    to = Math.min(totalCount, (timesClicked - 1) * itemsPerClick)

  return (
    <Tooltip2 content={`Previous Page (items ${from} - ${to})`}>
      <PrimaryIconButton wrapperClassName={css.navRight} icon={<Icon icon='arrow-left'/>}
                         onClick={onPageBack}/>
    </Tooltip2>)
})

const NextPageButton = observer(() => {
  const {storeNode: {productStore: {onPageForward, itemsPerClick, timesClicked, totalCount}}} = useGroupByGroupStore(),
    from = (timesClicked) * itemsPerClick + 1,
    to = Math.min(totalCount, (timesClicked + 1) * itemsPerClick)

  return (
    <Tooltip2 content={`Next Page (items ${from} - ${to})`}>
      <PrimaryIconButton wrapperClassName={css.navRight} icon={<Icon icon='arrow-right'/>}
                         onClick={onPageForward}/>
    </Tooltip2>)
})

const StackToolbarButton = observer<{ tooltip, icon: IconName, view: StackView }>(({tooltip, icon, view}) => {
  const store = useGroupByGroupStore(),
    {onClickStackView, settings: {stackView}} = store

  return <Tooltip2 content={tooltip}>
    <PrimaryIconButton icon={<Icon icon={icon}/>}
                       grouped
                       active={stackView == view}
                       onClick={onClickStackView(view)}
    />
  </Tooltip2>
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupByGroupHeaderStacked.tsx